import React from 'react';
import { useSelector } from 'react-redux';

import styles from './LandingErrorMessage.module.scss';

import config from '../../config/config';
import Phone from '../../components/Phone/Phone';
import {
  DOB_FAILURE,
  ADDRESS_INCOMPLETE,
  ALL_FUNDS_AUTO_SELL,
  ALL_FUNDS_AUTO_EXCHANGE,
  ALL_FUNDS_AUTO_SELL_EXCHANGE,
  MISSING_USERNAME,
  FOREIGN_ADDRESS,
  RMD_ELIGIBLE_AGE_CHECK,
  RMD_ELIGIBLE_ACCOUNT_CHECK,
  TOLL_FREE_NUMBER,
  REPRESENTATIVE_NUMBER,
  DISBURSEMENT_TYPE,
  NO_ELIGIBLE_ACCOUNTS,
  NOT_RMD_ELIGIBLE,
  ZERO_RMD_BALANCE,
  CHECK_SERVICE_FEATURE,
  UP_TO_THREE_HIDDEN_RMD_ELIGIBE_IRA,
  MORE_THAN_THREE_HIDDEN_RMD_ELIGIBE_IRA,
} from '../../settings/settings';
import { getRMDSummary } from '../../redux/modules/RMD/RMDSetting.selectors';

const LandingErrorMessage = ({ errorType, hiddenRMDFundIRAs }) => {
  const rmdInfo = useSelector((state) => getRMDSummary(state));
  /* No Eligible Accounts */
  if (errorType === NO_ELIGIBLE_ACCOUNTS) {
    return (
      <div className={styles.error}>
        Your account is currently not eligible for distribution.{' '}
        <span class="orphan-line">
          <a
            href={`${config.url}/personal-investing/help/contact/index.html`}
            rel="noopener noreferrer"
            target="_blank"
          >
            Contact us
          </a>
        </span>{' '}
        to speak with a Financial Consultant.
      </div>
    );
  }

  /* Missing username error */
  if (errorType === MISSING_USERNAME) {
    return (
      <div className={styles.error}>
        This user name does not match a T. Rowe Price Personal Investing
        account. Visit our{' '}
        <a
          className={styles['error-link']}
          href={`${config.url}/workplace/en/participant/home.html`}
        >
          Workplace Retirement
        </a>{' '}
        site or{' '}
        <a
          href={`${config.url}/personal-investing/help/contact/index.html`}
          rel="noopener noreferrer"
          target="_blank"
        >
          contact us
        </a>{' '}
        to speak with a representative.
      </div>
    );
  }

  /* Missing date of birth error */
  if (errorType === DOB_FAILURE) {
    return (
      <div className={styles.error}>
        We need your date of birth before you can set up an Auto-RMD.{' '}
        <a
          href={`${config.url}/personal-investing/help/contact/index.html`}
          rel="noopener noreferrer"
          target="_blank"
        >
          Contact us
        </a>{' '}
        to update your information.
      </div>
    );
  }
  /* Incomplete Address error */
  if (errorType === ADDRESS_INCOMPLETE) {
    return (
      <div className={styles.error}>
        We need an updated address before you can set up an Auto-RMD.{' '}
        <a
          className={styles['error-link']}
          href={`${config.url}/usis/my-accounts/profile/contact-information`}
        >
          Update your address
        </a>{' '}
        or{' '}
        <a
          href={`${config.url}/personal-investing/help/contact/index.html`}
          rel="noopener noreferrer"
          target="_blank"
        >
          contact us
        </a>{' '}
        to speak with a Financial Consultant.
      </div>
    );
  }
  /* Foreign Address error */
  if (errorType === FOREIGN_ADDRESS) {
    return (
      <div className={styles.error}>
        Your address must be based in the U.S. to set up an Auto-RMD.{' '}
        <a
          className={styles['error-link']}
          href={`${config.url}/usis/my-accounts/profile/contact-information`}
        >
          Update your address
        </a>{' '}
        or{' '}
        <a
          href={`${config.url}/personal-investing/help/contact/index.html`}
          rel="noopener noreferrer"
          target="_blank"
        >
          contact us
        </a>{' '}
        to speak with a Financial Consultant.
      </div>
    );
  }
  /* User is not RMD eligible due to age error */
  if (errorType === RMD_ELIGIBLE_AGE_CHECK) {
    return (
      <div className={styles.error}>
        You aren't eligible to take an RMD due to your age.{' '}
        <a
          className={styles['error-link']}
          href={`${config.url}/personal-investing/advice-and-planning/retirement-planning/living-in-retirement.html`}
        >
          Read more
        </a>{' '}
        about RMD eligibility.
      </div>
    );
  }
  /* User is not RMD eligible due to account types */
  if (errorType === RMD_ELIGIBLE_ACCOUNT_CHECK) {
    return (
      <div className={styles.error}>
        Your account types are not eligible for Auto-RMD. <br />
        <a
          href={`${config.url}/personal-investing/help/contact/index.html`}
          rel="noopener noreferrer"
          target="_blank"
        >
          Contact us
        </a>{' '}
        for more information.
      </div>
    );
  }
  if (errorType === ALL_FUNDS_AUTO_SELL) {
    return (
      <div className={styles.error}>
        You currently have a systematic withdrawal enabled on your IRA.
        Submitting your RMD request through this Auto-RMD Tool will not impact
        any existing systematic withdrawal programs. This may cause you to
        distribute more than the required minimum amount.
      </div>
    );
  }
  if (errorType === CHECK_SERVICE_FEATURE) {
    return (
      <div className={styles.error}>
        Online/phone redemption disabled.{' '}
        <a
          href={`${config.url}/personal-investing/help/contact/index.html`}
          rel="noopener noreferrer"
          target="_blank"
        >
          Contact us
        </a>{' '}
        to enable redemptions.
      </div>
    );
  }
  if (errorType === ALL_FUNDS_AUTO_EXCHANGE) {
    return (
      <div className={styles.error}>
        You currently have a systematic withdrawal enabled on your IRA.
        Submitting your RMD request through this Auto-RMD Tool will not impact
        any existing systematic withdrawal programs. This may cause you to
        distribute more than the required minimum amount.
      </div>
    );
  }
  if (errorType === ALL_FUNDS_AUTO_SELL_EXCHANGE) {
    return (
      <div className={styles.error}>
        You currently have a systematic withdrawal enabled on your IRA.
        Submitting your RMD request through this Auto-RMD Tool will not impact
        any existing systematic withdrawal programs. This may cause you to
        distribute more than the required minimum amount.  
      </div>
    );
  }
  if (errorType === DISBURSEMENT_TYPE) {
    return (
      <div className={styles.error}>
        You have an Auto-RMD in progress.{' '}
        <a
          href={`${config.url}/personal-investing/help/contact/index.html`}
          rel="noopener noreferrer"
          target="_blank"
        >
          Contact us
        </a>{' '}
        to make changes.
      </div>
    );
  }
  if (errorType === UP_TO_THREE_HIDDEN_RMD_ELIGIBE_IRA) {
    return (
      <div className={styles.error}>
        You currently have a filter in place to hide the following IRA account(s):{' '}
        {hiddenRMDFundIRAs?.map((fund, i) => (
         <span className="emphasis">{fund.name} - {fund.accountNumber}{(i < hiddenRMDFundIRAs.length - 1) ? ',' : '.'} </span>
        ))}
        In order to set up an Auto-RMD, please visit our{' '}
        <a href="https://www.troweprice.com/usis/my-accounts/accounts">
          Accounts page
        </a>{' '}
        and click "Customize" to update your filters. All eligible IRA accounts must
        be visible to proceed forward.
      </div>
    );
  }
  if (errorType === MORE_THAN_THREE_HIDDEN_RMD_ELIGIBE_IRA) {
    return (
      <div className={styles.error}>
        You currently have a filter in place to hide several of your IRA accounts.
        In order to set up an Auto-RMD, please visit our{' '}
        <a href="https://www.troweprice.com/usis/my-accounts/accounts">
          Accounts page
        </a>{' '}
        and click "Customize" to update your filters. All eligible IRA accounts must
        be visible to proceed forward.
      </div>
    );
  }
  if (errorType === NOT_RMD_ELIGIBLE) {
    return <div className={styles.error}>{rmdInfo.reasonNotEligible}</div>;
  }

  if (errorType === ZERO_RMD_BALANCE) {
    return (
      <div className={styles.error}>
        The balance of your RMD eligible account(s) was $0 as of{' '}
        <span className="orphan-line">
          December 31st, {rmdInfo.rmdYear - 1}.
        </span>
      </div>
    );
  }
  return null;
};

export default LandingErrorMessage;
